/**
* @description
* # name controller --> studentsListController
* # As Controller --> studentsList
* brief comment controller shows the view for the main page of assignTimeRange
*/

export default class studentsListController {
	constructor($scope,studentsServices,ngNotify,UserInfoConstant,$state,$filter,) {
		this.$scope = $scope;
		this.ngNotify = ngNotify;
		this.$state = $state;
		this.services = studentsServices.services
		this.buttonActions = true
		this.$scope.grid = false;
		this.$scope.edit = true;
		this.$scope.titleList = true;
		this.$translate = $filter('translate')
		this.conceptId = 0
		this.$scope.genderSelect = null
		this.$scope.code = null
		this.esValido = 0
		

		this.$scope.UserInfoConstant = UserInfoConstant;
		this.$scope.$watch('UserInfoConstant[0].details[0]', (details) => {
			if (details !== undefined) {
				this.user = details.user.id;
				this.user_id = details.user.id;
				this.conceptId = details.user.conceptId
				this.init()
			}
		});

	}

	init(){
		const params = {
			concept_id: this.conceptId
		}

		this.studentsList(params)
		this.getGenders()
	}
	
	studentsList(params){
		this.services.getStudents(params).$promise.then((dataReturn) => {
			if(dataReturn.results.lenght == 0){
				this.ngNotify.set('no existen registros','warn')
			}else{
				this.students = []
				this.studentsList = dataReturn.results;
				for (let i in this.studentsList){
					this.students.push({
						title: this.studentsList[i].ds_name + ' ' + this.studentsList[i].ds_last_name,
						name: this.studentsList[i].ds_name,
						lastName: this.studentsList[i].ds_last_name,
						id_code: this.studentsList[i].id_code,
						cod: this.studentsList[i].ds_code,
						rut: this.studentsList[i].ds_rut,
						badges: [
							{
								label: ( (this.studentsList[i].is_active === true) ? this.$translate('ACTIVE') : this.$translate('INACTIVE')),
								bg: ( (this.studentsList[i].is_active === true) ? "bg-success" : "bg-dark" ),
								icon: "mdi-check"
							}
						]
					})
				}
			}
		}, (err) => {
			this.ngNotify.set('No se ha podido conectar con el servicio','error');
		})
	}

	getGenders(){
		this.genders = [
			{
				id_code: 1,
				ds_name: 'femenino'
			},
			{
				id_code: 2,
				ds_name: 'masculino'
			}
		]
    }

	onClick(item){
		this.studentId=item.id_code;
		this.code = item.cod;
		this.studentName=item.name;
		this.lastName=item.lastName;
		this.getDetailsFunction({student_id:this.studentId});
		this.panelConfig = true
		this.buttonActions = false
	}

	getDetailsFunction(params){
		this.services.getStudentDetails(params).$promise.then((dataReturn) => {
			if(dataReturn.results && Object.keys(dataReturn.results).length === 0){
				this.ngNotify.set('registro seleccionado no tiene registros','warn');

			}else{
				this.student = dataReturn.results
				this.$scope.genderSelect = this.student.id_gender
				this.lastName = this.student.ds_last_name
				this.rut = this.student.ds_rut
				this.email = this.student.ds_mail
				this.nameAttorney = this.student.ds_name_attorney
			}
		}, (err) => {
			this.ngNotify.set('No se ha podido conectar con el servicio','error');
		})

	}

	edit(){
		this.$scope.editSave = true;
		this.$scope.edit = false;
		this.$scope.titleList = false;
		this.$scope.titleEdit = true;
		this.$scope.isDisabled = false;
	}

	cancelEdit(){
		this.$scope.editSave = false;
		this.$scope.edit = true;
		this.$scope.titleList = true;
		this.$scope.titleEdit = false;
		this.getDetailsFunction({student_id : this.studentId});
		
	}

	saveEdit(){
		if(this.studentName === null || this.studentName === '') {
			this.ngNotify.set('Indique nombre','warn')
			return
		}
		
		const params = {
			student_id: this.studentId,
			name: this.studentName,
			ds_last_name: this.lastName,
			ds_rut: this.rut,
			ds_name_attorney: this.nameAttorney,
			gender_id: this.$scope.genderSelect,
			ds_mail: this.email,
			concept_id: this.conceptId,
			user_id: this.user_id
		}

		this.services.updateStudents(params).$promise.then((dataReturn) => {
			if(dataReturn.status == 0){
				this.ngNotify.set('Se ha modificado de manera correcta el Estudiante','success');
				this.$state.go(this.$state.current, {}, {reload: true});
				this.$scope.edit = true;
				this.$scope.editSave = false;
				this.$scope.titleList = true;
				this.$scope.titleEdit = false;

			}else{
				if (dataReturn.isUniqueViolation) {
					this.ngNotify.set('Nombre de Estudiante se repite','error');
				}
				this.$scope.isDisabled = false;
			}
		}, (err) => {
			if (err.data.isUniqueViolation) {
				this.ngNotify.set('Nombre de Estudiante ya existe','error');
			} else {
				this.ngNotify.set('No se ha podido conectar con el servicio','error');
			}
			this.$scope.isDisabled = false;
		})

	}

	validarRut(rut) {
		if(rut === undefined || rut.length < 9 || !rut.includes('-')) { 
			this.ngNotify.set('Ingrese Rut','warn')
			return
		}
		rut = rut.toUpperCase()
		rut = rut.trim().split('-')

		const rutString = this.validarString(rut[0])
		const dvr = this.validarString(rut[1])
		let largo = rutString.length;
		let factor = 2;
		let contador = 0;
		let caracter = 0;
		let suma = 0;
		let cdv = '123456789K0';

		while (largo !== 0) {
			caracter = parseInt(rutString.charAt(largo - 1), 10);
			suma = suma + (caracter * factor);
			largo = largo - 1;
			factor = factor + 1;
			if (factor === 8) {
				factor = 2;
			}
		}

		let dv = 11 - (suma % 11)
		this.esValido = (cdv.charAt(dv - 1) === dvr) ? 1 : 0

		if(this.esValido) {
			this.ngNotify.set('Rut válido','success')
		} else {
			this.ngNotify.set('Rut inválido','warn')
		}

		return
	}

	validarString(cadena) {
		let resultado = cadena.trim()
		resultado = resultado.replace(/[^a-zA-Z0-9]/g, '')
	  
		return resultado;
	}

	toggleList(isHide) {
		this.$scope.toggle = isHide
	}
}
studentsListController.$inject=['$scope', 'studentsServices', 'ngNotify','UserInfoConstant','$state','$filter']


// WEBPACK FOOTER //
// ./src/app/admin-panel/students/list/studentsListController.js